module.exports = __webpack_public_path__ + "images/emoji/black_medium_square.04b813aad3f77cce9b69.png";